module.exports = __webpack_public_path__ + "img/man-filled-green.45d33791.svg";